import { useState } from 'react';

export type SearchMode = 'keyword' | 'semantic';

const STORAGE_KEY = 'marketplace-search-mode';

function readPreferredMode(): SearchMode {
  try {
    if (localStorage.getItem(STORAGE_KEY) === 'semantic') return 'semantic';
  } catch {
    return 'keyword';
  }
  return 'keyword';
}

export function usePreferredSearchMode(): [
  SearchMode,
  (mode: SearchMode) => void,
] {
  const [mode, setMode] = useState<SearchMode>(readPreferredMode);

  const setPreferredMode = (nextMode: SearchMode) => {
    setMode(nextMode);
    try {
      localStorage.setItem(STORAGE_KEY, nextMode);
    } catch {
      return;
    }
  };

  return [mode, setPreferredMode];
}
